import { InjectionToken, Type } from '@angular/core';
import { ProductTypeId } from '../constants';
import { GridRowType } from '@shared';
import { IChangeset } from '@shared-data';
import { IPricingItem } from './pricing-item.interface';

export const CHANGESET_ROW = new InjectionToken<
  Record<ProductTypeId, new (...args: any[]) => GridRowType & IChangeset>
>('CHANGESET_ROW');
